"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FORMATTING_TOKENS = void 0;
exports.FORMATTING_TOKENS = /(\[[^[]*\])|([-_:/.,()\s]+)|(YYYY|YY?|MM?M?M?|DD?|WW?|hh?|HH?|mm?|ss?|OT?)/g;
//# sourceMappingURL=common.constant.js.map